/**
 * Product brochure cta functionality.
 *
 * @module feature-product-downloads
 * @version 1.0.0
 * @author Robby Van den Broecke
 */

const selectBrochures = document.querySelectorAll(
  '.js-brochure-direct-download',
);

/**
 * Copy value from selected option to href
 * @param {string} value value of selected option.
 */

/**
 * get selected option value
 */
function DownloadBrochureOnChange() {
  if (!selectBrochures.length) return;

  selectBrochures.forEach((download) => {
    download.addEventListener('change', (e) => {
      const el = e.target;
      const selectedString = el.options[el.selectedIndex].value;
      const openModalId = el.options[el.selectedIndex].getAttribute('data-modal');
      const modal = document.getElementById(openModalId);
      const modalDialog = modal && modal.querySelector('.modal-dialog');

      if (selectedString && !openModalId) {
        // require a URL
        // window.location = selectedString; // redirect
        window.open(selectedString, '_blank');
      } else if (modal) {
        modal.classList.add('show');
        modal.style.display = 'block';
        document.body.classList.add('modal-open');
        modal.setAttribute('aria-modal', 'true');
        modal.setAttribute('aria-hidden', 'false');

        // Close modal when close button is clicked
        const closeButton = modal.querySelector('[data-dismiss="modal"]');
        closeButton.addEventListener('click', () => closeBrochureModal(modal, el));

        // Close modal when clicking outside of it
        modal.addEventListener('click', (event) => {
          if (event.target === modalDialog) {
            closeBrochureModal(modal, el);
          }
        });
      }

      return false;
    });
  });
}

function closeBrochureModal(modal, select) {
  const modalElement = modal;
  const selectElement = select;
  // Reset select value, so user can reselect if desired
  selectElement.selectedIndex = 0;

  // close modal
  modalElement.classList.remove('show');
  modalElement.style.display = 'none';
  document.body.classList.remove('modal-open');
  modalElement.setAttribute('aria-modal', 'false');
  modalElement.setAttribute('aria-hidden', 'true');
}

// On document ready
document.addEventListener('DOMContentLoaded', () => {
  DownloadBrochureOnChange();
});
